var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createApi, fetchBaseQuery, } from '@reduxjs/toolkit/query/react';
import camelcaseKeys from 'camelcase-keys';
import accessoriesTransformResponse from '../apiResponseTransformers/accessories';
import legacyInventoryTransformResponse from '../apiResponseTransformers/legacyInventory';
import transformPaymentResponse, { transformMultiplePaymentsResponse, } from '../apiResponseTransformers/payment';
import transformLegacyProtectionResponse from '../apiResponseTransformers/legacyProtection';
import transformSummaryResponse from '../apiResponseTransformers/summary';
import transformOffersResponse from '../apiResponseTransformers/offers';
import transformWarrantiesResponse from '../apiResponseTransformers/warranties';
import transformAuthResponse from '../apiResponseTransformers/userAuth';
import { apiModes } from '../../utils/constants';
var MULTIPLE_PAYMENTS_CHUNK_SIZE = 10;
var MULTIPLE_OFFERS_CHUNK_SIZE = 25;
// Split multiple payment requests into chunks of 10
var chunkArray = function (array) {
    var result = [];
    for (var i = 0; i < array.length; i += MULTIPLE_PAYMENTS_CHUNK_SIZE) {
        result.push(array.slice(i, i + MULTIPLE_PAYMENTS_CHUNK_SIZE));
    }
    return result;
};
// API slice for legacy Honda REST API, e.g., 'api.honda.ca', 'uat-api.honda.ca'
var hondaRestApi = createApi({
    reducerPath: 'hondaRestApi',
    baseQuery: fetchBaseQuery(),
    tagTypes: ['saved_build'],
    endpoints: function (builder) { return ({
        getAccessories: builder.query({
            query: function (_a) {
                var url = _a.url, params = _a.params;
                return ({ url: url, params: params });
            },
            transformResponse: accessoriesTransformResponse,
        }),
        getPayment: builder.query({
            query: function (_a) {
                var url = _a.url, body = _a.body, languageCode = _a.languageCode;
                return ({
                    url: url,
                    method: 'POST',
                    body: body,
                    headers: { 'Accept-Language': languageCode },
                    data: { AcceptLanguage: languageCode },
                });
            },
            // @ts-ignore
            transformResponse: transformPaymentResponse,
        }),
        getMultiplePayments: builder.query({
            queryFn: function (arg, _queryApi, _extraOptions, baseQuery) {
                return __awaiter(this, void 0, void 0, function () {
                    var result, chunks, results, data;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!(arg.body.length <= MULTIPLE_PAYMENTS_CHUNK_SIZE)) return [3 /*break*/, 2];
                                return [4 /*yield*/, baseQuery({
                                        url: arg.url,
                                        method: 'POST',
                                        body: arg.body,
                                    })];
                            case 1:
                                result = (_a.sent());
                                if (result.data) {
                                    return [2 /*return*/, { data: transformMultiplePaymentsResponse(result.data, undefined, arg) }];
                                }
                                _a.label = 2;
                            case 2:
                                chunks = chunkArray(arg.body);
                                return [4 /*yield*/, Promise.all(chunks.map(function (chunk) {
                                        return baseQuery({
                                            url: arg.url,
                                            method: 'POST',
                                            body: chunk,
                                        });
                                    }))];
                            case 3:
                                results = _a.sent();
                                data = results.reduce(function (acc, result) {
                                    if (result.data) {
                                        acc.push.apply(acc, result.data);
                                    }
                                    return acc;
                                }, []);
                                return [2 /*return*/, { data: transformMultiplePaymentsResponse(data, undefined, arg) }];
                        }
                    });
                });
            },
        }),
        getInventoryStatus: builder.query({
            query: function (_a) {
                var url = _a.url, body = _a.body;
                return ({ url: url, method: 'POST', body: body });
            },
            transformResponse: legacyInventoryTransformResponse,
        }),
        getProtection: builder.query({
            query: function (_a) {
                var url = _a.url;
                return ({ url: url });
            },
            transformResponse: transformLegacyProtectionResponse,
        }),
        getBuildPriceSummary: builder.query({
            query: function (_a) {
                var url = _a.url, body = _a.body, languageCode = _a.languageCode;
                return ({
                    url: url,
                    method: 'POST',
                    body: body,
                    headers: { 'Accept-Language': languageCode },
                    data: { AcceptLanguage: languageCode },
                });
            },
            transformResponse: transformSummaryResponse,
        }),
        getOffers: builder.query({
            query: function (_a) {
                var hostname = _a.hostname, transmissionIds = _a.transmissionIds, provinceCode = _a.provinceCode, languageCode = _a.languageCode, productLineCode = _a.productLineCode, pageState = _a.pageState;
                return "".concat(hostname, "/models/").concat(productLineCode, "/").concat(apiModes[pageState], "/BuildAndPrice/offers/").concat(transmissionIds, "/province/").concat(provinceCode, "?AcceptLanguage=").concat(languageCode);
            },
            transformResponse: transformOffersResponse,
        }),
        getMultipleOffers: builder.query({
            queryFn: function (arg, _queryApi, _extraOptions, baseQuery) {
                return __awaiter(this, void 0, void 0, function () {
                    var hostname, transmissionIds, provinceCode, languageCode, productLineCode, pageState, transmissionIdsList, requestUrls, transmissionIdsChunk, getUrl, idx, transmissionId, isChunkReady, results, parsedResults;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                hostname = arg.hostname, transmissionIds = arg.transmissionIds, provinceCode = arg.provinceCode, languageCode = arg.languageCode, productLineCode = arg.productLineCode, pageState = arg.pageState;
                                transmissionIdsList = transmissionIds.split(';');
                                requestUrls = [];
                                transmissionIdsChunk = [];
                                getUrl = function (ids) {
                                    return "".concat(hostname, "/models/").concat(productLineCode, "/").concat(apiModes[pageState], "/BuildAndPrice/offers/").concat(ids, "/province/").concat(provinceCode, "?AcceptLanguage=").concat(languageCode);
                                };
                                for (idx = 0; idx < transmissionIdsList.length; idx++) {
                                    transmissionId = transmissionIdsList[idx];
                                    // eslint-disable-next-line no-continue
                                    if (!transmissionId)
                                        continue;
                                    transmissionIdsChunk.push(transmissionId);
                                    isChunkReady = transmissionIdsChunk.length === MULTIPLE_OFFERS_CHUNK_SIZE ||
                                        (transmissionIdsChunk.length && idx === transmissionIdsList.length - 1);
                                    if (isChunkReady) {
                                        requestUrls.push(getUrl(transmissionIdsChunk.join(';')));
                                        transmissionIdsChunk = [];
                                    }
                                }
                                return [4 /*yield*/, Promise.all(requestUrls.map(function (url) { return baseQuery(url); }))];
                            case 1:
                                results = _a.sent();
                                parsedResults = results.map(function (result) { return transformOffersResponse(result.data); }).flat();
                                return [2 /*return*/, { data: parsedResults }];
                        }
                    });
                });
            },
        }),
        getOffersWithLoyalty: builder.query({
            query: function (_a) {
                var hostname = _a.hostname, transmissionIds = _a.transmissionIds, provinceCode = _a.provinceCode, languageCode = _a.languageCode, productLineCode = _a.productLineCode, pageState = _a.pageState;
                return "".concat(hostname, "/models/").concat(productLineCode, "/").concat(apiModes[pageState], "/BuildAndPrice/offers/").concat(transmissionIds, "/province/").concat(provinceCode, "/withloyalty?AcceptLanguage=").concat(languageCode);
            },
            transformResponse: transformOffersResponse,
        }),
        getWarranties: builder.query({
            query: function (_a) {
                var hostname = _a.hostname, transmissionIds = _a.transmissionIds, provinceCode = _a.provinceCode, languageCode = _a.languageCode, productLineCode = _a.productLineCode, bodyStyle = _a.bodyStyle, term = _a.term, annualKmAllowance = _a.annualKmAllowance, paymentMethod = _a.paymentMethod, pageState = _a.pageState;
                var baseQuery = "".concat(hostname, "/models/").concat(productLineCode, "/").concat(apiModes[pageState], "/transmissions/").concat(transmissionIds, "/warranties?AcceptLanguage=").concat(languageCode, "&provinceCode=").concat(provinceCode, "&bodyStyle=").concat(bodyStyle, "&term=").concat(term, "&paymentMethod=").concat(paymentMethod);
                if (annualKmAllowance) {
                    return "".concat(baseQuery, "&kmAllowance=").concat(annualKmAllowance);
                }
                return baseQuery;
            },
            transformResponse: transformWarrantiesResponse,
        }),
        getSavedBuild: builder.query({
            query: function (_a) {
                var url = _a.url, headers = _a.headers;
                return ({ url: url, headers: headers });
            },
            providesTags: function (_result, _error, arg) { return [{ type: 'saved_build', id: arg.buildId }]; },
            transformResponse: function (response) { return camelcaseKeys(response, { deep: true }) || {}; },
        }),
        getUserAuth: builder.query({
            query: function (_a) {
                var url = _a.url;
                return ({ url: url, credentials: 'include' });
            },
            transformResponse: transformAuthResponse,
        }),
    }); },
});
export var hondaRestApiReducer = hondaRestApi.reducer;
export var hondaRestApiMiddleware = hondaRestApi.middleware;
export var useGetInventoryStatusQuery = hondaRestApi.useGetInventoryStatusQuery, useGetAccessoriesQuery = hondaRestApi.useGetAccessoriesQuery, useGetPaymentQuery = hondaRestApi.useGetPaymentQuery, useGetMultiplePaymentsQuery = hondaRestApi.useGetMultiplePaymentsQuery, useGetProtectionQuery = hondaRestApi.useGetProtectionQuery, useGetBuildPriceSummaryQuery = hondaRestApi.useGetBuildPriceSummaryQuery, useGetOffersQuery = hondaRestApi.useGetOffersQuery, useGetMultipleOffersQuery = hondaRestApi.useGetMultipleOffersQuery, useGetOffersWithLoyaltyQuery = hondaRestApi.useGetOffersWithLoyaltyQuery, useGetWarrantiesQuery = hondaRestApi.useGetWarrantiesQuery, useGetSavedBuildQuery = hondaRestApi.useGetSavedBuildQuery, useGetUserAuthQuery = hondaRestApi.useGetUserAuthQuery;
export default hondaRestApi;
